import { Stack, Typography } from "@mui/material";
import { usePayPointCredentialQuery } from "Api/Queries/PayPoints/usePayPointCredentialQuery";
import { FormSection } from "Components/Shared/FormSection";
import { Resources, useResource } from "Translations/Resources";
import { formatDate } from "Utils/DateUtils";

const FORM_RESOURCES = Resources.Paypoint.Form;
const DEVICE_RESOURCES = Resources.Paypoint.Form.Device;
const LIST_RESOURCES = Resources.Devices.List;

type Props = {
  payPointPublicID: string;
};

export const PaypointDeviceSection = ({ payPointPublicID }: Props) => {
  const { t } = useResource();
  const { data: credential } = usePayPointCredentialQuery(payPointPublicID);
  const hasActiveDevice = !!credential?.publicID;

  return (
    <FormSection legend={t(FORM_RESOURCES.Legend.Device)}>
      {hasActiveDevice ? (
        <Stack>
          <Typography variant="body1" fontWeight={500}>
            {credential?.name}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {t(LIST_RESOURCES.LastUsedAt)}:{" "}
            {credential?.lastUsedAt
              ? formatDate(credential.lastUsedAt, true)
              : "—"}
          </Typography>
        </Stack>
      ) : (
        <Typography variant="body2" color="text.secondary">
          {t(DEVICE_RESOURCES.NoActiveDevice)}
        </Typography>
      )}
    </FormSection>
  );
};
